import { Controller } from "@hotwired/stimulus"

// Real-time password-strength checklist. Watches a password input and
// toggles --ok/--pending classes on three rule-status elements based on
// the current value:
//   - at least 8 characters
//   - contains a letter
//   - contains a number
//
// Usage:
//   div data-controller="password-strength"
//     input[type=password] data-password-strength-target="input"
//                          data-action="input->password-strength#update"
//     ul
//       li data-password-strength-target="ruleLength"
//       li data-password-strength-target="ruleLetter"
//       li data-password-strength-target="ruleNumber"
export default class extends Controller {
  static targets = ["input", "ruleLength", "ruleLetter", "ruleNumber"]

  connect() { this.update() }

  update() {
    if (!this.hasInputTarget) return
    const v = this.inputTarget.value
    this.setRule(this.hasRuleLengthTarget ? this.ruleLengthTarget : null, v.length >= 8)
    this.setRule(this.hasRuleLetterTarget ? this.ruleLetterTarget : null, /[a-zA-Z]/.test(v))
    this.setRule(this.hasRuleNumberTarget ? this.ruleNumberTarget : null, /\d/.test(v))
  }

  setRule(target, satisfied) {
    if (!target) return
    target.classList.toggle("password-strength-rule--ok", satisfied)
    target.classList.toggle("password-strength-rule--pending", !satisfied)
  }
}
